export { FeatureSpecDataModule } from './lib/feature-spec-data.module';
export { FeatureSpecActions, FeatureSpecSelectors } from './lib/entity/feature-spec.store';
export { FeatureSpecHttpClient } from './lib/entity/feature-spec.http-client';
export * from './lib/entity/feature-spec.types';
